<template>
  <div class="fixed-bottom-right">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.fixed-bottom-right {
  z-index: 100;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 96px);
  right: 16px;
}
</style>